import React, { useState } from "react";
import emailjs from "emailjs-com";
import { Helmet } from "react-helmet-async";
import "./Message.css";

const Message = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
    });

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        emailjs
            .send(
                "service_6pu91bj",
                "template_7psvftr",
                formData,
                "GxBcqZQ0rmlTHi8Bn"
            )
            .then(
                (response) => {
                    setSuccessMessage("Signup email sent successfully!");
                    setIsSubmitting(false);
                    setFormData({ name: "", email: "", phone: "", message: "" });
                },
                (error) => {
                    console.error("Failed to send email:", error);
                    setIsSubmitting(false);
                }
            );
    };

    return (
        <>
            <Helmet>
                <title>Contact Us | AptoWebsites - Web Development & Digital Solutions</title>
                <meta name="description" content="Contact AptoWebsites for expert web development, design, and digital solutions. Fill out our form to start your project today." />
                <meta name="keywords" content="Contact, Web Development, Web Design, Digital Solutions, AptoWebsites, Signup, Business Inquiry" />
                <meta property="og:title" content="Contact Us | AptoWebsites" />
                <meta property="og:description" content="Reach out to AptoWebsites for expert web solutions. Let's build your online presence together." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://aptowebsites.com/contact" />
                <meta property="og:image" content="https://aptowebsites.com/og-image.jpg" />
                <link rel="canonical" href="https://aptowebsites.com/contact" />
                <script type="application/ld+json">
                    {`
                    {
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        "name": "AptoWebsites",
                        "url": "https://aptowebsites.com",
                        "contactPoint": {
                            "@type": "ContactPoint",
                            "email": "info@aptowebsites.com",
                            "contactType": "customer support"
                        }
                    }
                    `}
                </script>
            </Helmet>
            <main className="message-container" aria-label="Contact Form Section">
                <section className="message-card">
                    <h1>Contact Us</h1>
                    <form onSubmit={handleSubmit} aria-label="Contact Form">
                        <div className="form-group">
                            <label htmlFor="name">Name</label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                placeholder="Your Name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                                aria-required="true"
                                autoComplete="name"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="email">Email</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                placeholder="Your Email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                aria-required="true"
                                autoComplete="email"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="phone">Phone Number</label>
                            <input
                                type="tel"
                                id="phone"
                                name="phone"
                                placeholder="Your Phone Number"
                                value={formData.phone}
                                onChange={handleChange}
                                required
                                aria-required="true"
                                autoComplete="tel"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="message">Message</label>
                            <input
                                type="text"
                                id="message"
                                name="message"
                                placeholder="Your Message"
                                value={formData.message}
                                onChange={handleChange}
                                required
                                aria-required="true"
                            />
                        </div>
                        <button type="submit" className="message-btn" disabled={isSubmitting} aria-busy={isSubmitting}>
                            {isSubmitting ? "Submitting..." : "Contact Us"}
                        </button>
                    </form>
                    {successMessage && <p className="success-message" role="status">{successMessage}</p>}
                </section>
            </main>
        </>
    );
};

export default Message;
